import './ExpertsItemCard.scss';
import React from 'react';
import { useInView } from 'react-intersection-observer';


function ExpertsItemCard(data) {
  const{ ref,inView } = useInView({
    threshold:0,
  })
  return (
    <div ref={ref} className={`card-wrapper animation ${inView ? 'show-experts-card': ""}`}>
      <div className="expert-card">
        <div className="expert-photo">
          <img src={data.photo} alt="team" />
        </div>
        <div className="expert-text-wrapper">
          <div className="expert-text-block">
              <div className="expert-capture-wrapper">
                  <div className="expert-info">
                      <div className="expert-name">
                      {data.name}
                      </div>
                      <div className="expert-position">
                      {data.position}
                      </div>
                  </div>
                  <div className="expert-social-link">
                      <a href={data.link} target='blank'> <img src={data.imageLink} alt="experts link" /></a>
                  </div>
              </div>
              <div className="expert-description">
                  {data.description}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpertsItemCard;